import request from "../utils/request";
import store from "@/store/store";
export async function getIsDayOpening() {
    return request.get("DayReport/IsDayOpening");
  }

  export async function getIsDayInterim() {
    return request.get("DayReport/IsDayInterim");
  }

  export async function createDayOpen(dayOpenData) {
    return request.post("DayReport/CreateDayOpen", dayOpenData);
  }

  export async function createDayInterim(interimData) {
    return request.post("DayReport/CreateDayInterim", interimData);
  }

  export async function createDayClose(closeData) {
    return request.post("DayReport/CreateDayClose", closeData);
  }

  export async function getBranchOpenClose() {
    return request.get("DayReport/GetBranchOpenClose");
  }

  /** Gün sonu öncesi DayOpening / şube tutarlılığı (teşhis). */
  export async function getDayCloseReadiness() {
    return request.get("DayReport/DayCloseReadiness");
  }

  export async function getDayReports(payload) {
    return request.get("DayReport/GetPaged?", {
      params: {
        sortBy: payload.sortBy,
        sortDirection: payload.sortDirection,
        pageIndex: payload.pageIndex,
        pageSize: payload.pageSize,
        branchId: payload.branch != null || payload.branch != undefined ? payload.branch.id : null,
        startDate: payload.dateRange && payload.dateRange.startDate ? payload.dateRange.startDate.toDateString() : null,
        startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
        endDate: payload.dateRange && payload.dateRange.endDate ? payload.dateRange.endDate.toDateString() : null,
        endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
        type: payload.dayReportType!=null ? payload.dayReportType.id: null
      }
    });
  }

  export async function getById(id) {
    return request.get("DayReport/GetById?id="+id);
  }


  export async function getRealTime() {
    return request.get("DayReport/GetRealTime");
  }

  export async function GetExcel(id) {
    return request.get("DayReport/GetExcel?id="+id, {
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.ms-excel'
      }
    })
  }

  export async function uploadImage(image) {
    return request({
      method: 'post',
      url: 'UploadImage/',
      data: image,
      config: {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    });
  }